module.exports = __webpack_public_path__ + "img/progress.6f2548ac.svg";